export default defineNuxtRouteMiddleware(async (to) => {
  // if (to.meta.originalName === 'search') {
  const { $gtag } = useNuxtApp();
  const jobsSearchStore = useJobsSearchStore();
  await jobsSearchStore.lazyInit(to.query);
  $gtag?.logSearch();
  // }
});
